export enum DeliveryGroupType {
  PickUp = "PICK_UP",
  DropOff = "DROP_OFF",
  Start = "START",
  End = "END",
  Rest = "REST",
  Split = "SPLIT",
  SPLIT = "SPLIT",
}
